export default __webpack_public_path__ + "static/media/theme.5dcab5b0.png";